/** Traslados del caso a otra área: los de un caso y sus acciones (trasladar o pedirlo, decidir, cancelar). */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AreaTransferView, CaseAreaTransfersView, CreateAreaTransferInput, DecideAreaTransferInput } from '@pqrs/contracts';
import { apiGet, apiPost } from '@/api/client';
import { caseKeys } from '@/features/cases/api';

export const areaTransferKeys = { case: (caseId: string) => ['area-transfers', 'case', caseId] as const };

export const useCaseAreaTransfers = (caseId: string, enabled = true) => useQuery({ queryKey: areaTransferKeys.case(caseId), queryFn: () => apiGet<CaseAreaTransfersView>(`/area-transfers/cases/${caseId}`), enabled });

/** Un traslado cambia el área, el responsable y las tareas: se recarga todo el caso y las bandejas. */
function useInvalidateTransfer() {
  const qc = useQueryClient();
  return (caseId: string) => {
    void qc.invalidateQueries({ queryKey: areaTransferKeys.case(caseId) });
    void qc.invalidateQueries({ queryKey: caseKeys.all });
    void qc.invalidateQueries({ queryKey: ['assignments'] });
  };
}

export function useCreateAreaTransfer(caseId: string) {
  const inv = useInvalidateTransfer();
  return useMutation({ mutationFn: (input: CreateAreaTransferInput) => apiPost<AreaTransferView>(`/area-transfers/cases/${caseId}`, input), onSuccess: () => inv(caseId) });
}
export function useDecideAreaTransfer(caseId: string) {
  const inv = useInvalidateTransfer();
  return useMutation({ mutationFn: ({ id, ...input }: DecideAreaTransferInput & { id: string }) => apiPost<AreaTransferView>(`/area-transfers/${id}/decide`, input), onSuccess: () => inv(caseId) });
}
export function useCancelAreaTransfer(caseId: string) {
  const inv = useInvalidateTransfer();
  return useMutation({ mutationFn: ({ id, reason }: { id: string; reason: string }) => apiPost<AreaTransferView>(`/area-transfers/${id}/cancel`, { reason }), onSuccess: () => inv(caseId) });
}
